import React, { useEffect, useRef, useState } from 'react';
import PopupHandler from './PopupHandler';
import graph from './graph';

import { useSelector } from 'react-redux';
import { isEmptyObject } from 'helpers/formatObject';
import { useLazyQuery } from '@apollo/client';
import { useGeolocation } from 'hooks/geoHook';

export default function MainModel(props) {
  const { initFilter, isPopup = false } = props;
  const init = { ...initFilter };

  const [startFetch, setStartFetch] = useState(!isPopup);
  const [flag, setFlag] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(12);
  const [total, setTotal] = useState(0);
  const [result, setResult] = useState([]);
  const [filter, setFilter] = useState(init);
  const { userToken } = useSelector((state) => state.auth);

  const userLocation = useGeolocation();
  const requestIdRef = useRef(0);
  const ignoreFormUpdatesRef = useRef(false);

  const clearFilter = () => {
    ignoreFormUpdatesRef.current = true;
    const nextFilter = { ...init };
    setPage(1);
    setResult([]);
    setFilter(nextFilter);
    setFlag((prev) => !prev);
    if (startFetch) {
      handleData(false, nextFilter);
    }
    window.setTimeout(() => {
      ignoreFormUpdatesRef.current = false;
    }, 150);
  };

  const handleSetFilter = (nextFilter) => {
    if (ignoreFormUpdatesRef.current) return;
    setPage(1);
    setResult([]);
    setFilter(nextFilter);
  };

  const [getData, { loading }] = useLazyQuery(graph.list.query, {
    context: {
      serviceName: graph.list.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const refresh = () => {
    setPage(1);
    setResult([]);
    setFlag(!flag);
  };

  const handleData = async (paginate, nextFilter = filter) => {
    const requestId = ++requestIdRef.current;
    try {
      const { data, error } = await getData({
        fetchPolicy: 'network-only',
        variables: {
          ...nextFilter,
          page: paginate ? page : 1,
          limit,
          lat: String(userLocation.latitude),
          lng: String(userLocation.longitude),
        },
      });
      if (requestId !== requestIdRef.current) return;
      if (!isEmptyObject(data) && !error) {
        const res = data[graph.list.name];
        setTotal(res?.total);
        paginate ? setResult((prevData) => prevData.concat(res?.data)) : setResult(res?.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    startFetch && handleData(page > 1);
  }, [startFetch, page, filter, flag]);

  return (
    <PopupHandler
      page={page}
      limit={limit}
      total={total}
      result={result}
      filter={filter}
      loading={loading}
      refetch={refresh}
      setPage={setPage}
      isPopup={isPopup}
      clearFilter={clearFilter}
      setFilter={handleSetFilter}
      setStartFetch={setStartFetch}
      {...props}
    />
  );
}
